import { CartLinesUpdateEvent } from '@shopify/events';

async function szvAddToCart(items, sourceEl) {
  const sectionIds = [...document.querySelectorAll('cart-items-component')]
    .map((c) => c.dataset.sectionId)
    .filter(Boolean);
  const deferred = CartLinesUpdateEvent.createPromise();
  (sourceEl || document.body).dispatchEvent(
    new CartLinesUpdateEvent({
      action: 'add',
      context: 'product',
      lines: items.map((i) => ({ merchandiseId: String(i.id), quantity: i.quantity })),
      promise: deferred.promise,
    })
  );
  try {
    const res = await fetch(Theme.routes.cart_add_url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items, sections: sectionIds.join(',') }),
    }).then((r) => r.json());
    const cart = await fetch(`${Theme.routes.cart_url}.js`, { headers: { Accept: 'application/json' } }).then((r) => r.json());
    const failed = Boolean(res.status);
    deferred.resolve({
      cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart),
      detail: {
        items: cart.items,
        itemCount: items.reduce((s, i) => s + i.quantity, 0),
        sections: failed ? undefined : res.sections,
        source: 'product-form-component',
        didError: failed,
      },
    });
    if (failed) throw new Error(res.description || res.message || 'add failed');
    const drawer = document.getElementById('cart-drawer');
    if (drawer && typeof drawer.open === 'function' && !drawer.isOpen) setTimeout(() => drawer.open(), 60);
    return cart;
  } catch (e) {
    try { deferred.reject(e); } catch (_) {}
    throw e;
  }
}
window.szvAddToCart = szvAddToCart;

/* cart drawer upsell (delegated, survives section re-renders) */
document.addEventListener('click', async (e) => {
  const sw = e.target.closest('[data-szv-up-sw]');
  if (sw) {
    const box = sw.closest('.szvu');
    box.querySelectorAll('[data-szv-up-sw]').forEach((b) => b.classList.toggle('is-sel', b === sw));
    const n = box.querySelector('[data-szv-up-name]');
    if (n) n.textContent = sw.dataset.name;
    box.dataset.variant = sw.dataset.id;
    return;
  }
  const add = e.target.closest('[data-szv-up-add]');
  if (add) {
    const box = add.closest('.szvu');
    add.disabled = true;
    try {
      await szvAddToCart([{ id: Number(box.dataset.variant), quantity: 1 }], box);
    } catch (_) {
      add.disabled = false;
    }
  }
});
